import { Injectable } from '@angular/core'
import { ParseService } from 'src/app/parse.service'

type GTag = (arg1: 'event', arg2: 'conversion' | 'purchase', arg3: object) => void

declare global {
    interface Window {
        dataLayer?: unknown[]
        gtag: (arg1: unknown, arg2: unknown) => void
    }
}

@Injectable({
    providedIn: 'root',
})
export class GoogleTagService {
    constructor(private parseService: ParseService) {
        if (!window.dataLayer) {
            window.dataLayer = []
        }
    }

    get gTag(): GTag | undefined {
        return window.gtag as GTag | undefined
    }

    sendPurchaseAndConversionEvent(
        value: number,
        currency: 'USD' = 'USD',
        itemName: 'Mailing Order' | 'Mailing List Order',
        transactionId: string = Date.now().toString()
    ): void {
        try {
            //  Run only on production environments
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            const gTag = this.gTag
            if (gTag) {
                // gTag('event', 'conversion',
                //     {
                //         send_to: 'AW-706516239/NdunCNr9qboBEI-q8tAC', //  Ad Words
                //         value,
                //         currency,
                //         transaction_id: '' + Date.now()
                //     }
                // );

                // Google Analytics 4 Purchase Event
                gTag('event', 'purchase', {
                    send_to: 'G-PQ9D4P46DC',
                    currency,
                    value,
                    transaction_id: transactionId,
                    items: [{ item_name: itemName }],
                })
            }

            this.pushToDataLayer(value, transactionId, itemName)
        } catch (error) {
            this.parseService.reportUIError(error, 'GoogleTagService.sendPurchaseConversionEvent', JSON.stringify({}))
        }
    }

    private pushToDataLayer(value: number, transactionId: string, itemName: string): void {
        const user = this.parseService.user.value

        const ecData: {
            value: number
            email?: string
            phone_number?: string
            first_name?: string
            last_name?: string
            home_address?: {
                street?: string
                city?: string
                region?: string
                postal_code?: string
                country?: string
            }
        } = { value }

        if (user) {
            ecData.email = user.username
            ecData.first_name = user.firstName
            ecData.last_name = user.lastName
            ecData.phone_number = user.phone
        }

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'orderComplete',
                ecData,
                transaction_id: transactionId,
                items: [{ item_name: itemName }],
            })
        }
    }
}
